import type { ReactNode } from 'react'
import { InfoTooltip } from '~/shared/ui/info-tooltip'

interface BillingCellProps {
  label: string
  info?: string
  action?: ReactNode
  children: ReactNode
}

export function BillingCell({ label, info, action, children }: BillingCellProps) {
  return (
    <div className="flex min-w-0 flex-col gap-1.5 p-5">
      <div className="flex min-h-8 items-center justify-between gap-2">
        <span className="flex min-w-0 items-center gap-1 font-medium text-muted-foreground text-xs uppercase tracking-[0.06em]">
          <span className="truncate">{label}</span>
          {info ? <InfoTooltip label={label}>{info}</InfoTooltip> : null}
        </span>
        {action}
      </div>
      {children}
    </div>
  )
}
